export default __webpack_public_path__ + "static/media/i-finalizado_connect.af519367.svg";